"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Common util to abstract the tag content according if a product
 * is still considered new
 *
 * @param {boolean} isNew
 * @param {string} content
 * @returns {string}
 */
const handleTag = (isNew, content) => {
    if (isNew) {
        return 'New';
    }
    if (content) {
        return content;
    }
    return null;
};
exports.default = handleTag;
//# sourceMappingURL=handleTag.js.map